import React, { useState, useEffect } from "react";
import Translations from "../../services/translation.service";
import TimeUp from "../../assets/img/time_up.svg";
import StorefrontTitle from "./storefront-title.component";
import User from "../../services/user.service";
import Storage from "../../services/storage.service";
import Numbers from "../../services/numbers.service";
import storefront from "../../services/storefront.service";
import moment from "moment";
import Translation from "../../services/translation.service";
import Summaries from "../../services/summaries.service";
import StmSummary from "./storefront-summary";
import SpinnerTimeLoader from "./timeLoading";
import FirebaseAnalytics from "../../services/firebaseAnalytics";
import CONSTANTS from "../../services/constants.service";

const subscriptions = [];
const DropOffScreen = ({toggleDropOff}) => {
  const [translationKeys, setTranslationsKeys] = useState(
    Translations.keys ? Translations.keys : {}
  );
  const [loading, setLoading] = useState(false);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [numberExpiry, setNumberExpiry] = useState(0);
  const [selectedNumber, setSelectedNumber] = useState(null);
  const [selectedVaniity, setSelectedVaniity] = useState(null);
  const [bookingStatus, setBookingStatus] = useState(null);

  const getNumberDetailNew = async () => {

    

    setLoading(true)
    let numberCheck = Storage.get("number", true) || await getNumberFromSummary();
    setLoading(true);
    Numbers.getNumberStats()
      .then(response => {
        setLoading(false);
        let data = (response.data.numbers.find((item) => item.MSISDN === (numberCheck)));
        if (data.MSISDN) {
            setSelectedNumber(data.MSISDN);
            setSelectedVaniity(data.VanityLevelId);
            setNumberExpiry(data.ExpiryDate);            
            // setBookingStatus(5);
            setBookingStatus(data.BookingStatus);
            // setStepperVal("1");
            // if (data.BookingStatus === 5) {

            // }
        } else {
          setLoading(false);
        }
      })
      .catch(error => {
          setLoading(false);
      })
  }

  useEffect(() => {
    getNumberDetailNew();
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    subscriptions.push(
      Translations.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
        setLoading(false);
      })
    );

    // Storage.get_obsrv("number_obj").subscribe(data => {
    //     if (data) {
    //       setSelectedNumber(JSON.parse(data.MSISDN));
    //       setSelectedVaniity(JSON.parse(data.VanityLevelId));
    //     }
    // });

    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    };
  }, []);

  const handleChooseAnother = async () => {
    FirebaseAnalytics.button_clicked( CONSTANTS.DROP_OFF_SCREEN, translationKeys["stm_number_status_choose_no"])
    // Case: Number might or might not be expired yet.
    setLoading(true);
    let numberCheck = Storage.get("number", true) || await getNumberFromSummary();
    User.getFlowStatus().then(
        res => {
            if (res.data.flow_status_flags.IsMnp === true) {
                Numbers.mnpCancel((numberCheck).trim())
                  .then(response => {
                      // setLoading(false);
                      User.fetchFlowStatus(7)
                        .then((res) => {
                            // Storage.clear("choose_random_number")
                            // Storage.clear("random_number")
                            // Storage.clear("choose_mnp");
                            // localStorage.removeItem("TabSwitched");
                            // sessionStorage.removeItem("TabSwitchedBack");
                            handleDropOffContinuity();
                            Storage.clear("number");
                            setLoading(false);
                        })
                        .catch((error) => { 
                            setLoading(false); 
                        });
                  })
                  .catch(error => { 
                      setLoading(false); 
                  })
            } else {
                Numbers.cancel(numberCheck)
                  .then(response => {
                      Storage.clear("number");
                      User.fetchFlowStatus(7)
                        .then((res) => {
                          // Storage.clear("choose_random_number")
                          // Storage.clear("random_number")
                          // Storage.clear("choose_mnp");
                          // localStorage.removeItem("TabSwitched");
                          // sessionStorage.removeItem("TabSwitchedBack");
                          handleDropOffContinuity();
                          Storage.clear("number");
                          setLoading(false);
                        })
                        .catch((error) => { 
                            setLoading(false); 
                        });
                  })
                  .catch(error => { 
                      setLoading(false); 
                  })
            }
        })
        .catch(error => { 
            setLoading(false)
        });
}

  const handleRequestAgain = async () => {
    FirebaseAnalytics.button_clicked( CONSTANTS.DROP_OFF_SCREEN, translationKeys["stm_number_status_request_again"])
    setLoading(true);
    // Case: Number has expired. Now trying to register same number again.
    let numberCheck = Storage.get("number", true) || await getNumberFromSummary()
    console.log("handleRequestAgain");
    Numbers.postNumber(numberCheck)
    .then((response) => {
        if(response) {
          // setStepperVal("3");
          User.fetchFlowStatus(7)
          .then((res) => {
              handleDropOffContinuity();
              setLoading(false);
          })
          .catch((error) => { 
              setLoading(false); 
          });
          setLoading(false);
        }
    })
    .catch(error => {
        // Error Logged
    })
  }

  const getNumberFromSummary = async () => {
    setSummaryLoading(true);
    let MSISDN = null;
    await Summaries.getSummary()
    .then((res) => {
      if (res?.data?.number_details) {
        if(res.data.number_details.MSISDN) {
          Storage.set("number", res.data.number_details.MSISDN, true);
          setSelectedNumber(res.data.number_details.MSISDN);
          setSelectedVaniity(res.data.number_details.VanityLevelID);
          MSISDN = res.data.number_details.MSISDN;
          setSummaryLoading(false);
        }
      }
    })
    .catch(() => {
      setSummaryLoading(false);
    })
    return MSISDN;
  }


  const handleDropOffContinuity = () => {
    if(toggleDropOff){
      toggleDropOff()
      localStorage.removeItem("TabSwitched");
      sessionStorage.removeItem("TabSwitchedBack");
    }
  }

  const handleContinue = async () => {
    FirebaseAnalytics.button_clicked( CONSTANTS.DROP_OFF_SCREEN, translationKeys["stm_number_status_continue"])
    setLoading(true);
    let numberCheck = Storage.get("number", true) || await getNumberFromSummary();
    Numbers.getNumberStats()
    .then(response => {
      // handleDropOffContinuity();
      let data = (response.data.numbers.find((item) => item.MSISDN === (numberCheck)));
      if (data.MSISDN) {
          setSelectedNumber(data.MSISDN);
          setSelectedVaniity(data.VanityLevelId);
          setNumberExpiry(data.ExpiryDate);            
          setBookingStatus(data.BookingStatus);
          if (data.BookingStatus === 5) {
            Numbers.postNumber(data.MSISDN)
            .then((response) => {
                if(response) {
                  // setStepperVal("2");
                  handleDropOffContinuity();
                  setLoading(false);
                }
                // props.closeDropOffScreen();
                // localStorage.removeItem("TabSwitched");
                // sessionStorage.removeItem("TabSwitchedBack");
                // User.fetchFlowStatus();
            })
            .catch(error => {
                // Error Logged
            })
          } else {
            Numbers.confirmRandomNumber()
            .then(() => {
                User.fetchFlowStatus(7)
                .then((res) => {
                    handleDropOffContinuity();
                    setLoading(false);
                })
                .catch((error) => { 
                    setLoading(false); 
                });
                // setStepperVal("2");
            })
            .catch(error => {
                console.log("Error", error);
                setLoading(false);
            })
          }
      } else {
        setLoading(false);
      }
    })
    .catch(error => {
        setLoading(false);
    })
  };

  const getColorFromVanity = (Vanitylevel) => {
    // GET VANITY COLOR
    let style = {};
    let theme = Storage.get("theme", true);
    let vanity_theme = "vanity_level";
    let theme_parsed = JSON.parse(theme);
    if (theme && vanity_theme && theme_parsed) {
      let style_value_comp = vanity_theme + Vanitylevel;
      if (style_value_comp) {
        let style_value = theme_parsed[style_value_comp];
        style["color"] = style_value;
      }
    }
    return style;
  }

  const getExpiryTimeToShow = () => {
    let startTime = moment(numberExpiry).utc();
    let seconds = moment(startTime).diff(moment(), 'seconds');
    let datH = moment.duration(seconds, "seconds").hours();
    let datM = moment.duration(seconds, "seconds").minutes();

    if (datH > 0) {
        if (datH > 1) {
            return `${moment(startTime).diff(moment(), 'hours')} ${translationKeys["stm_drop_off_hours_until_we"]}`;
        } else {
            return `${moment(startTime).diff(moment(), 'hours')} ${translationKeys["stm_drop_off_hour_until_we"]}`;
        }
    } else if (datM > 0) {
        if (datM > 1) {
            return `${moment(startTime).diff(moment(), 'minutes')} ${translationKeys["stm_drop_off_minutes_until_we"]}`;
        } else {
            return `${moment(startTime).diff(moment(), 'minutes')} ${translationKeys["stm_drop_off_minute_until_we"]}`;
        }
    } else {
        return `${moment(startTime).diff(moment(), 'seconds')} ${translationKeys["stm_drop_off_seconds_until_we"]}`;
    }
  }

  const getExpiryTime = () => {
    let startTime = moment(numberExpiry).utc();
    return moment(startTime).diff(moment(), 'seconds');
  }

  return (
		<div className="storefront-two-col-pg">
      <div className="number-stm-main">
        {loading || summaryLoading ? (
          <SpinnerTimeLoader />
        ) : (
          <div className="number-stm-wrapper">
            <img src={TimeUp} alt="time-icon" />
            {getExpiryTime() < 0 ?
              // Time up
              <StorefrontTitle
                title={Translation.keys["stm_number_status_failed_title"]}
                desc={Translation.keys["stm_number_status_failed_disc"]}
              />
            : 
              // Has Some Time
              <StorefrontTitle
                title={getExpiryTime() > 0 && getExpiryTimeToShow()}
                desc={Translation.keys["stm_number_status_initiate_disc"]}
              />
            }
            {selectedNumber &&
              <div className="number-selection-container stm-number-card-btn">
                <div className="details-container">
                  <img
                    className="badge-section"
                    src={storefront.getPoImage("stf_vanity_img", `stf_vanity_${selectedVaniity}`)}
                    alt=""
                  />
                  <div className="details-section">
                    <div className="number-section">
                      {Numbers.get_number_pieces(selectedNumber, selectedVaniity, null, getColorFromVanity(selectedVaniity))}
                    </div>
                    <p className="number-text" style={getColorFromVanity(selectedVaniity)}>
                      {translationKeys[`general_vanity_name_${selectedVaniity}number`]}
                    </p>
                  </div>
                </div>
              </div>
            }
            <div className="buttons-confirm">
              {bookingStatus === 5 && 
                <button
                  className="storefront-button stm-number-btn"
                  onClick={() => handleRequestAgain()}
                >
                  {translationKeys["stm_number_status_request_again"]}
                </button>
              }

              {bookingStatus === 1 && getExpiryTime() > 0 &&
                <button
                  className="storefront-button stm-number-btn"
                  onClick={() => handleContinue()}
                >
                  {translationKeys["stm_number_status_continue"]}
                </button>
              }

              {bookingStatus === 1 && getExpiryTime() < 0 &&
                <button
                  className="storefront-button stm-number-btn"
                  onClick={() => handleContinue()}
                >
                  {translationKeys["stm_number_status_request_again"]}
                </button>
              }
            
              {bookingStatus &&
                <button
                  className="storefront-button stm-number-btn2"
                  onClick={() => handleChooseAnother()}
                >
                  {translationKeys["stm_number_status_choose_no"]}
                </button>
              }
            </div>
          </div>
        )}
      </div>
      <StmSummary />
    </div>	
  );
};

export default DropOffScreen;
